import React from 'react';
import { MailIcon, MapPinIcon, MessageCircleIcon, ClockIcon, HeadphonesIcon } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { OrderForm } from '../components/OrderForm';
import { company } from '../data/company';
import { commodities } from '../data/products';
import { whatsappLink } from '../utils/contact';
const steps = [{
  step: '01',
  title: 'Send your specification',
  text: 'Commodity, quantity, destination port and preferred incoterm. Trial lots are welcome for first-time buyers.'
}, {
  step: '02',
  title: 'Receive a firm offer',
  text: 'Within 24 hours you get pricing basis, specification sheet, documentation list and a draft contract.'
}, {
  step: '03',
  title: 'Verify the goods',
  text: 'Inspection at our warehouse or by your nominated agent, with independent assay and umpire clause.'
}, {
  step: '04',
  title: 'Payment and shipment',
  text: 'LC at sight or bonded escrow, then sealed-container dispatch with tracking through to delivery.'
}];
export function Contact() {
  return <>
      <PageHeader eyebrow="Trading desk" title="Place an order or speak to a trader" intro="Email the desk with a pre-filled enquiry, message us directly on WhatsApp, or ask our help centre assistant anything about grades, terms and logistics." image={commodities[0].image} imageAlt="Refined gold bullion bars" data-id="element-302" data-mp="19fyzkvrh14qo" />

      <section className="mx-auto max-w-shell px-6 py-16" data-id="element-303" data-mp="qi69iu1y4pap">
        <div className="grid gap-10 lg:grid-cols-[1.25fr_1fr] lg:items-start" data-id="element-304" data-mp="qiocsan103s4">
          <OrderForm data-id="element-305" data-mp="vg7ph642s8hy" />

          <div className="space-y-6" data-id="element-306" data-mp="vfobg0hjq497">
            <div className="border border-hair bg-panel p-6" data-id="element-307" data-mp="10gc5yw4zh386">
              <h2 className="font-display text-2xl text-bone" data-id="element-308" data-mp="10hnch3ptcp2z">Direct channels</h2>
              <ul className="mt-6 space-y-5 text-sm" data-id="element-309" data-mp="26vmnmd80t6en">
                <li className="flex gap-3" data-id="element-310" data-mp="2bv8zai87aelc">
                  <MessageCircleIcon className="mt-0.5 h-4 w-4 shrink-0 text-[#25D366]" aria-hidden="true" data-id="element-311" data-mp="2bu7rcmmhe87u" />
                  <span data-id="element-312" data-mp="1m5sk9x3ngcm9">
                    <span className="block font-mono text-[10px] uppercase tracking-[0.16em] text-muted" data-id="element-313" data-mp="1m96mn5cbcltp">
                      WhatsApp
                    </span>
                    <a href={whatsappLink()} target="_blank" rel="noreferrer" className="text-bone transition-colors duration-150 hover:text-gold-light" data-id="element-314" data-mp="1w517m740eszn">
                      Chat with the trading desk
                    </a>
                  </span>
                </li>
                <li className="flex gap-3" data-id="element-315" data-mp="1d7ql7n3h7u1m">
                  <MailIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-316" data-mp="1d8rxtw054olg" />
                  <span data-id="element-317" data-mp="18dvs5t1ze2pv">
                    <span className="block font-mono text-[10px] uppercase tracking-[0.16em] text-muted" data-id="element-318" data-mp="kq4h0ss6fvq6">
                      Email
                    </span>
                    <a href={`mailto:${company.email}`} className="text-bone transition-colors duration-150 hover:text-gold-light" data-id="element-319" data-mp="fr1b764dhlh5">
                      {company.email}
                    </a>
                  </span>
                </li>
                <li className="flex gap-3" data-id="element-320" data-mp="2hia5d65xjqy9">
                  <ClockIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-321" data-mp="2mf0k9q600gi3" />
                  <span data-id="element-322" data-mp="3a5e62yxzpj48">
                    <span className="block font-mono text-[10px] uppercase tracking-[0.16em] text-muted" data-id="element-323" data-mp="3a660w7jrjctg">
                      Desk hours
                    </span>
                    <span className="text-bone" data-id="element-324" data-mp="314pzuqeu8n1w">{company.hours}</span>
                  </span>
                </li>
                {company.offices.map(office => <li key={office.label} className="flex gap-3" data-id="element-325" data-mp="3584hflifdbhg">
                    <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-326" data-mp="1po864y2mkyiy" />
                    <span data-id="element-327" data-mp="1trxsdgvtv40t">
                      <span className="block font-mono text-[10px] uppercase tracking-[0.16em] text-muted" data-id="element-328" data-mp="1ts7hz3cyn95z">
                        {office.label}
                      </span>
                      {office.lines.map(line => <span key={line} className="block text-bone" data-id="element-329" data-mp="2087njedn1epn">
                          {line}
                        </span>)}
                    </span>
                  </li>)}
              </ul>
              <a href={whatsappLink()} target="_blank" rel="noreferrer" className="mt-7 block rounded-sm bg-[#25D366] px-5 py-3 text-center text-sm font-semibold text-[#0a2f16] transition-colors duration-150 hover:bg-[#1fbe5a]" data-id="element-330" data-mp="2svk85j08ncgb">
                Open WhatsApp chat
              </a>
            </div>

            <div className="border border-hair bg-panel p-6" data-id="element-331" data-mp="17jsk7p3vcku5">
              <HeadphonesIcon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-332" data-mp="17h7geuk0futr" />
              <h2 className="mt-4 font-display text-2xl text-bone" data-id="element-333" data-mp="13gnihorm4n6k">Help centre assistant</h2>
              <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-334" data-mp="3f753w9wnht6c">
                Kito, our customer assistant, answers questions on minimum quantities, pricing basis,
                assay standards, documentation and shipping times instantly — open it from the button
                at the bottom right of any page.
              </p>
            </div>

            <div className="border border-hair bg-panel p-6" data-id="element-335" data-mp="1r74jydxvavw">
              <h2 className="font-display text-2xl text-bone" data-id="element-336" data-mp="1sqk1mrrthwm">CEO&apos;s office</h2>
              <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-337" data-mp="6rlexn30iwx3">
                For long-term offtake agreements and joint ventures, contact the office of{' '}
                {company.ceo}, Chief Executive Officer, marking your email &ldquo;Offtake — CEO
                office&rdquo;.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="border-t border-hair bg-panel2/40 py-16" data-id="element-338" data-mp="2hibgu5bx40wz">
        <div className="mx-auto max-w-shell px-6" data-id="element-339" data-mp="3krxp46w40z2o">
          <h2 className="font-display text-3xl text-bone" data-id="element-340" data-mp="3kspm9m5cv4v2">From enquiry to delivery</h2>
          <ol className="mt-10 grid gap-px border border-hair bg-hair sm:grid-cols-2 lg:grid-cols-4" data-id="element-341" data-mp="3fuxle2mqg8eq">
            {steps.map(item => <li key={item.step} className="flex flex-col bg-ink p-7" data-id="element-342" data-mp="3ou15n9xmytut">
                <span className="font-mono text-xs text-gold" data-id="element-343" data-mp="3osq31dfxfs5a">{item.step}</span>
                <h3 className="mt-3 text-base font-semibold text-bone" data-id="element-344" data-mp="7kcsyck5v2a9">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-345" data-mp="2lrou21sfygj">{item.text}</p>
              </li>)}
          </ol>
        </div>
      </section>
    </>;
}